module.exports = __webpack_public_path__ + "static/sigma-5-21b05839cef038e575a996599e5d315c.png";